import { UNKNOWN_VIEW_STATE_SCOPE } from './constants'
import type { Scope } from './types'

export const scopeToString = (scope: Scope | undefined): string => {
  return scope
    ? `${scope.type}.${scope.scope}.${scope.id}`
    : UNKNOWN_VIEW_STATE_SCOPE
}

export const scopeToInternalString = (scope: Scope | undefined): string => {
  return scope ? `${scope.type}.${scope.scope}` : UNKNOWN_VIEW_STATE_SCOPE
}

export const isScopeIdRandomNanoId = (key: string): boolean => {
  const scopeId = key.split('.')?.length > 2 ? key.split('.')[2] : null
  if (!scopeId) return false
  // Regular expression for matching a nanoid (default length of 21, using alphanumeric characters + '-' and '_')
  const nanoidRegex = /[a-zA-Z0-9_-]{21}/

  return nanoidRegex.test(scopeId)
}
